var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 21.492V25.5013H0V21.5066C1.86127 19.0192 4.27721 17.0004 7.05572 15.6107C9.83423 14.221 12.8987 13.4987 16.0053 13.5013C22.544 13.5013 28.352 16.64 32 21.492ZM21.336 5.49996C21.336 6.91445 20.7741 8.271 19.7739 9.27119C18.7737 10.2714 17.4172 10.8333 16.0027 10.8333C14.5882 10.8333 13.2316 10.2714 12.2314 9.27119C11.2312 8.271 10.6693 6.91445 10.6693 5.49996C10.6693 4.08547 11.2312 2.72892 12.2314 1.72872C13.2316 0.728529 14.5882 0.166626 16.0027 0.166626C17.4172 0.166626 18.7737 0.728529 19.7739 1.72872C20.7741 2.72892 21.336 4.08547 21.336 5.49996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a65c98cb6afb618ffffa11dc7d8e1f46.svg";
export { ForwardRef as ReactComponent };